import { HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FileTypeT3 } from 'src/app/core/enums/user/file-type';
import { revisionHistoryAccessTypeEnum } from 'src/app/core/models/ckEditor/revisionData';
import { SelfAssessmentDocumentModel } from 'src/app/core/models/self-assessment/self-assessment-document-model';
import { SelfAssessmentInterpretation } from 'src/app/core/models/self-assessmentT3/SelfAssessmentInterpretation';
import { UserProfile } from 'src/app/core/models/user';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { SelfAssessmentTemplate3Service } from 'src/app/core/services/self-assessment-template3/self-assessment-template3.service';
import { SignalRService } from 'src/app/core/services/signalR/signal-r.service';
import { ModalDialogComponent } from '../../distributed-ui-components/modal-dialog/modal-dialog.component';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { overallAssessmentDropdownList } from 'src/app/core/models/self-assessmentT3/overallDropdownList';
import { FrontComponent } from '../shared-components/front/front.component';
import { VersionHistoryT3DataDto } from 'src/app/core/models/self-assessmentT3/version-filter-viewT3-model';
import { breadCrumbsList } from 'src/app/core/models/breadCrumbs/breadCrumbs';
import { cloneDeep } from 'lodash';
import { rightsManagementSAT3Dto } from 'src/app/core/models/self-assessmentT3/SelfAssessmentT3Filter';
import { GlobalService } from 'src/app/core/services/global/global.service';

@Component({
  selector: 'app-interpretations-t3',
  templateUrl: './interpretations-t3.component.html',
  styleUrls: ['./interpretations-t3.component.scss'],
})
export class InterpretationsT3Component {
  NumberOfInterpretation: number = 1;
  OrginalTab: boolean = true;
  @Input() summaryDetailsId!: string;
  summaryId: number = 0;
  InterpretationId: number = 0;
  isLoader: boolean = true;
  ShowTab: boolean = false;
  selfAssessmentId: number;
  interpretationList: SelfAssessmentInterpretation;
  previousInterpretationList: SelfAssessmentInterpretation | undefined;
  interpretationEvidanceLoader: boolean = false;
  isAssessmentLastEdited: boolean = false;
  active: number = 0;
  isReviewLastEdited: boolean = false;
  isActionLastEdited: boolean = false;
  isReviewLoader: boolean = false;
  isToastShow = false;
  isLoading: boolean = true;
  interpretationAssessmentDropdownList: overallAssessmentDropdownList =
    new overallAssessmentDropdownList();
  isActionLoader: boolean = false;
  selfAssessmentDocument: SelfAssessmentDocumentModel[] = [];
  isCheckedForConditionalApproval: boolean = false;
  isInterpretationDisabled: boolean = true;
  activatedTab: number = 0;
  showTab: boolean = false;
  accessType: revisionHistoryAccessTypeEnum | undefined;
  user: UserProfile = new UserProfile();
  @ViewChild('uploadEviAssessmentT3') uploadEviAssessmentT3: any;
  toastModel: ToastViewModel = new ToastViewModel();
  @ViewChild(FrontComponent) frontComponent!: FrontComponent;
  breadCampsList: breadCrumbsList[] = [];
  constructor(
    private _sessionService: SessionService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private _selfAssessmentT3Service: SelfAssessmentTemplate3Service,
    @Inject(MAT_DIALOG_DATA)
    public versionHistoryData: VersionHistoryT3DataDto,
    private ref: ChangeDetectorRef,
    private _globalService: GlobalService
  ) {
    this.NumberOfInterpretation = 1;
    this.interpretationList = new SelfAssessmentInterpretation();
    this.previousInterpretationList = new SelfAssessmentInterpretation();
    this.accessType = revisionHistoryAccessTypeEnum.All;
    this.selfAssessmentId = 0;
    this.breadCampsList = [
      { name: 'Assessment', className: 'active' },
      { name: 'Review', className: '' },
      { name: 'Approval', className: '' },
      { name: 'Approved', className: '' },
    ];
  }
  tabs: string[] = [];
  DefaultOpen() {
    if (this.tabs.length != 0) {
      this.InterpretationId = parseInt(this.tabs[0]);
      this.setTab(this.InterpretationId, 0);
    }
  }
  tab: number = 0;
  activatedTabIndex: number = 1;
  setTab(id: number, index: number) {
    this._globalService.selectedSubmitterName = '';
    this._globalService.selectedReviewerName = [];
    this._globalService.selectedApproverName = [];
    this._globalService.selectedCondApproverName = [];
    this.active = index;
    this.showTab = false;
    this.isLoader = true;
    this.tab = index + 1;
    this.getInterpretation(id);
  }
  ngOnInit() {
    if (this.versionHistoryData && this.versionHistoryData.isVersonHistory) {
      this.fetchInterpretationVersionHistoryData(
        this.versionHistoryData.overAssessmentId
      );
      this.tab = this.versionHistoryData.tab;
    } else {
      if (!this.summaryDetailsId) {
        this.route.params.subscribe((params: any) => {
          this.summaryDetailsId = params['id'];
          this.summaryId = parseInt(this.summaryDetailsId);
        });
      }
      this.getallInterpretation();
      this.AddInterpretation();
    }
    this.getUserDetails();
    this.getOverallAssessmentAllDropDowns();
  }
  getInterpretation(id: number) {
    this._selfAssessmentT3Service
      .getT3Interpretation(id)
      .subscribe((data: SelfAssessmentInterpretation) => {
        this.interpretationList = data;
        this.previousInterpretationList = cloneDeep(data);
        this.showTab = true;
        if (this.interpretationList.id > 0) {
          this.getAssessmentDocuments();
        }
        this.getLoaderOffCondition();
        this.breadCrumbsSet();
      });
  }
  fetchInterpretationVersionHistoryData(id: number) {
    this._selfAssessmentT3Service
      .getInterpretationVersionHistoryDetails(id)
      .subscribe((data: any) => {
        this.interpretationList = data;
        this.showTab = true;
        this.interpretationList.id = data.interpretationId;
        if (this.interpretationList.id > 0) {
          this.getAssessmentDocuments();
        }
        this.getLoaderOffCondition();
      });
  }
  uploadEvidenceInterpretation() {
    const fileInput = document.getElementById(
      'uploadEviAssessmentT3'
    ) as HTMLElement;
    fileInput.click();
  }
  handleFileInput(files: FileList) {
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], FileTypeT3.Interpretation);
    }
  }
  uploadFileToActivity(fileToUpload: any, fileType: FileTypeT3) {
    if (fileType === FileTypeT3.Interpretation) {
      this.interpretationEvidanceLoader = true;
    } else if (fileType === FileTypeT3.Review) {
      this.isReviewLoader = true;
    } else if (fileType === FileTypeT3.Action) {
      this.isActionLoader = true;
    }

    this._selfAssessmentT3Service
      .UploadEvidenceT3(fileToUpload, fileType, this.summaryDetailsId)
      .subscribe(
        (data: any) => {
          this.fetchSelfAssessmentDocuments(fileType);
          this.updateSectionLastEdited(fileType);
          if (fileType === FileTypeT3.OverAll) {
            this.interpretationEvidanceLoader = false;
          } else if (fileType === FileTypeT3.Review) {
            this.isReviewLoader = false;
          } else if (fileType === FileTypeT3.Action) {
            this.isActionLoader = false;
          }
        },
        (err: HttpErrorResponse) => {
          this.alertMessage(
            'warning',
            'File not uploaded, please check your file'
          );
          setTimeout(() => { }, 3500);
        }
      );
  }
  updateSectionLastEdited(filter: FileTypeT3): void {
    switch (filter) {
      case 1:
        this.isAssessmentLastEdited = true;
        break;
      case 2:
        this.isReviewLastEdited = true;
        break;
      case 3:
        this.isActionLastEdited = true;
        break;
    }
  }
  openDeleteModel(id: number, fileType: string): void {
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      data: {
        message: 'Are you sure want to delete?',
        title: 'Delete Document',
        btnText: 'Delete',
      },
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.removeSelfAssessmentDocumentsT3(id, fileType);
      }
    });
  }
  removeSelfAssessmentDocumentsT3(id: number, fileType: string): void {
    if (fileType === 'overall') {
      this.interpretationEvidanceLoader = true;
    } else if (fileType === 'review') {
      this.isReviewLoader = true;
    } else if (fileType === 'action') {
      this.isActionLoader = true;
    }
    this._selfAssessmentT3Service
      .deleteSelfAssessmentT3Document(id)
      .subscribe((data: any) => {
        if (data.result) {
          if (fileType === 'overall') {
            this.interpretationEvidanceLoader = false;
            this.fetchSelfAssessmentDocuments(FileTypeT3.OverAll);
          } else if (fileType === 'review') {
            this.isReviewLoader = false;
            this.fetchSelfAssessmentDocuments(FileTypeT3.Review);
          } else if (fileType === 'action') {
            this.isActionLoader = false;
            this.fetchSelfAssessmentDocuments(FileTypeT3.Action);
          }
          this.alertMessage('success', data.result);
        }
      });
  }
  addAdditonalInterpretation() {
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      data: {
        message: 'Are you sure want to add a new Interpretation?',
        title: 'Add New Interpretation',
        btnText: 'Ok',
      },
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this._selfAssessmentT3Service
          .addAdditionalInterpretationAssessment(
            parseInt(this.summaryDetailsId)
          )
          .subscribe((result: any) => {
            let data = result;
            this.getallInterpretation();
          });
      }
    });
  }
  //Returning the list of Interpretations Id
  getallInterpretation() {
    this._selfAssessmentT3Service
      .getAllInterpretationAssessmentById(parseInt(this.summaryDetailsId))
      .subscribe((data: any) => {
        this.tabs = data;
        this.DefaultOpen();
      });
  }
  getAssessmentDocuments() {
    this.interpretationEvidanceLoader = true;
    this.isReviewLoader = true;
    this._selfAssessmentT3Service
      .getSelfAssessmentT3InterpretationDocument(this.interpretationList.id)
      .subscribe((result: SelfAssessmentDocumentModel[]) => {
        this.selfAssessmentDocument = result;
        this.interpretationEvidanceLoader = false;
        this.isReviewLoader = false;
        this.getLoaderOffCondition();
      });
  }
  getOverallAssessmentAllDropDowns() {
    this._selfAssessmentT3Service
      .getT3InterpretationAssessmentDropdowns()
      .subscribe((res: overallAssessmentDropdownList) => {
        this.interpretationAssessmentDropdownList = res;
        this.getLoaderOffCondition();
      });
  }
  fetchSelfAssessmentDocuments(fileType: FileTypeT3) {
    if (fileType === FileTypeT3.OverAll) {
      this.interpretationEvidanceLoader = true;
    } else if (fileType === FileTypeT3.Review) {
      this.isReviewLoader = true;
    } else if (fileType === FileTypeT3.Action) {
      this.isActionLoader = true;
    }
    this._selfAssessmentT3Service
      .getSelfAssessmentT3OverallDocuments(parseInt(this.summaryDetailsId))
      .subscribe((result: SelfAssessmentDocumentModel[]) => {
        this.selfAssessmentDocument = result;
        if (fileType === FileTypeT3.OverAll) {
          this.interpretationEvidanceLoader = false;
        } else if (fileType === FileTypeT3.Review) {
          this.isReviewLoader = false;
        } else if (fileType === FileTypeT3.Action) {
          this.isActionLoader = false;
        }
      });
  }
  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3500);
  }
  AddInterpretation() {
    let i = this.NumberOfInterpretation.toString();
    this.tabs.push(i);
    this.NumberOfInterpretation++;
    this.tabs;
  }
  ShowNewInterpretation() {
    this.OrginalTab = false;
  }
  getUserDetails() {
    this._sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
      this.user = user;
      this.getLoaderOffCondition();
    });
  }
  async saveInterpretationData() {
    this._selfAssessmentT3Service
      .saveInterpretationT3(this.interpretationList)
      .subscribe((x) => {
        this.alertMessage('success', 'InterPretaion saved successfully');
        setTimeout(() => { }, 3500);
      });
  }

  @Output() notifyCkEditorChange: EventEmitter<any> = new EventEmitter<any>();
  notifyDetailsComponentCkEditorChange() {
    this.notifyCkEditorChange.emit();
  }

  async isReadyForReviewChanged(checked: boolean) {
    if (checked) {
      this.changeBreadCrumbs('Review');
    } else {
      this.changeBreadCrumbs('Assessment');
    }
  }

  isReadyForApprovalChanged(checked: boolean) {
    if (checked) {
      this.changeBreadCrumbs('Approval');
    } else {
      this.changeBreadCrumbs('Review');
    }
  }

  isReadyForConditionalApprovalChanged(checked: boolean) {
    if (checked) {
      this.changeBreadCrumbs('Approved');
    } else {
      this.changeBreadCrumbs('Approval');
    }
  }

  changeBreadCrumbs(item: string) {
    if (this.breadCampsList) {
      // Use map to set className to "" for all items
      this.breadCampsList = this.breadCampsList.map((item) => {
        return { ...item, className: '' };
      });
      // Find the item with name 'Review' and update its className
      const index = this.breadCampsList.findIndex((ob) => ob.name === item);
      if (index !== -1) {
        //this.breadCampsList[reviewIndex].className = 'active'; // Set new class name for the 'Review' item
        this.breadCampsList = [
          ...this.breadCampsList
            .slice(0, index + 1)
            .map((item) => ({ ...item, className: 'active' })),
          ...this.breadCampsList.slice(index + 1),
        ];
      }
    }
  }

  breadCrumbsSet() {
    if (this.interpretationList.conditionalApproval == true) {
      this.changeBreadCrumbs('Approved');
    } else if (this.interpretationList.readyForApproval == true) {
      this.changeBreadCrumbs('Approval');
    } else if (this.interpretationList.readyForReview == true) {
      this.changeBreadCrumbs('Review');
    } else {
      this.changeBreadCrumbs('Assessment');
    }
  }

  isDataChange: boolean = false;
  performLeaveCheck(): boolean {
    const currentDataStr = JSON.stringify(this.interpretationList);
    const previousDataStr = JSON.stringify(this.previousInterpretationList);
    if (currentDataStr !== previousDataStr) {
      this.isDataChange = true;
      // Perform actions based on changes
    } else {
      this.isDataChange = false;
    }
    return this.isDataChange;
  }
  getLoaderOffCondition() {
    if (
      this.interpretationAssessmentDropdownList.actionClosedList &&
      this.interpretationAssessmentDropdownList.actionClosedList.length > 0 &&
      this.interpretationList.id > 0 &&
      this.selfAssessmentDocument &&
      this.user.fullName != ''
    ) {
      this.isLoader = false;
    }
  }
  setPreviousData(){
    this.previousInterpretationList = cloneDeep(this.interpretationList); 
  }
}
